<template>
    <div>
        <div class="grid grid-cols-12 gap-4" v-if="task.brn">
            <div class="col-span-12">
                <div class="flex flex-column">
                    <span class="font-bold text-blue h5">{{ task.brn }}</span>
                    <span class="font-bold text-gray h3">{{ task.companyName }}  </span>
                </div>
                <div class="flex mt-1">
                    <span class="text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                        Entity Type
                    </span>
                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs mx-1 bg-green text-capitalize">
                        {{ task.entityType }}
                    </span>

                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize mx-1">
                        Sub Type
                    </span>
                    <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs mx-1 bg-green text-capitalize">
                        {{ cleanEntityType(task.subType || '') }}
                    </span>

                </div>
                <span class="italic text-gray text-xs font-bold"
                      v-if="task.dateOfIncorporation">Registration Date: {{ dateFormat(task.dateOfIncorporation) }}

                </span><br/>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
                <table class="min-w-full leading-normal mt-1 text-blue-dark"
                       v-if="task.applicant"
                       style="border: solid 1px #bdd7f1;">
                    <thead>
                    <tr class="bg-primary-pale">
                        <td colspan="12" class="px-2 py-2">Applicant Details</td>
                    </tr>
                    <tr>
                        <th class="px-2 py-1">Name</th>
                        <th class="px-2 py-1">Email</th>
                        <th class="px-2 py-1">Phone</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="border: solid 1px #bdd7f1;">
                        <td class="px-2 py-1">
                            <span>{{ task.applicant.givenName }} {{ task.applicant.surname ? task.applicant.surname : "" }}</span>
                        </td>
                        <td class="px-2 py-1">
                            <span>{{ task.applicant.email }}</span>
                        </td>
                        <td class="px-2 py-1">
                            <span>{{ task.applicant.phoneNumber }}</span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="grid grid-cols-12 gap-4">
            <div class="col-span-12">
                <table class="min-w-full leading-normal mt-1 text-gray" style="border: solid 1px #dedede;">
                    <thead>
                    <tr class="bg-gray-pale">
                        <td colspan="12" class="px-2 py-2">Application Details</td>
                    </tr>
                    <tr>
                        <th class="px-2 py-1">Tracking Number</th>
                        <th class="px-2 py-1">Status</th>
                        <th class="px-2 py-1">Type</th>
                        <th class="px-2 py-1">Nature</th>
                        <th class="px-2 py-1">Process</th>
                        <th class="px-2 py-1">Submission Date</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="border: solid 1px #dedede;">
                        <td class="px-2 py-1">
                  <span class="text-gray">
                    {{ task.trackingNumber }}
                  </span>
                        </td>
                        <td class="px-2 py-1">
                            <span class="text-blue text-capitalize">{{ cleanUnderscores(task.status.toLowerCase()) }}</span>
                        </td>
                        <td class="px-2 py-1">
                            <span class="text-gray text-capitalize">{{ cleanUnderscores(task.type.toLowerCase()) }}</span>
                        </td>

                        <td class="px-2 py-1">
                            <span class="text-gray text-capitalize">{{ task.windingUpType ? cleanUnderscores(task.windingUpType.toLowerCase()) : "" }}</span>
                        </td>
                        <td class="px-2 py-1">
                            <span class="text-gray text-capitalize">{{ task.hasAsset === 'NO' ? 'Short' : 'Long' }} process</span>
                        </td>
                        <td class="px-2 py-1">
                  <span class="text-gray italic">
                    {{ dateTimeFormat(task.createdAt) }}
                  </span>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>


        <div class="grid grid-cols-12 gap-4" v-if="task != null">
            <div class="col-span-12" v-if="task.type ==='PETITION'">

                <table
                        v-if="task.amendments !== undefined"

                        class="min-w-full leading-normal my-1 text-gray"
                        style="border: solid 1px #dedede;">
                    <thead>
                    <tr class="bg-gray-pale">
                        <td colspan="12" class="px-2 py-2">Petition Details</td>
                    </tr>
                    <tr class="bg-gray-pale">
                        <td class="px-2 py-2 font-bold">Amendment Number</td>
                        <td class="px-2 py-2 font-bold">Nature Of Applicant</td>
                        <td class="px-2 py-2 font-bold">Nature Of Applicant Description</td>
                        <td class="px-2 py-2 font-bold">Subject</td>
                        <td class="px-2 py-2 font-bold">Complainants</td>
                        <td class="px-2 py-2 font-bold">Respondents</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr style="border: solid 1px #dedede;">

                        <td class="px-2 py-1 ">{{ task.petition.amendmentNumber }}</td>
                        <td class="px-2 py-1 ">{{ task.petition.natureOfApplicant }}</td>
                        <td class="px-2 py-1 ">{{ task.petition.natureOfApplicantDescription }}</td>
                        <td class="px-2 py-1 ">{{ task.petition.subject }}</td>
                        <td class="px-2 py-1 ">{{
                                task.petition.complainants.forEach(com => {
                                    return com.name + ','
                                })
                            }}
                        </td>
                        <td class="px-2 py-1 ">{{
                                task.petition.respondents.forEach(com => {
                                    return com.name + ','
                                })
                            }}
                        </td>
                    </tr>

                    </tbody>
                </table>


                <table
                        v-if="task.amendments !== undefined"

                        class="min-w-full leading-normal my-1 text-gray"
                        style="border: solid 1px #dedede;">
                    <thead>
                    <tr class="bg-gray-pale">
                        <td colspan="12" class="px-2 py-2"> Amendments to the petition</td>
                    </tr>
                    <tr class="bg-gray-pale">
                        <td class="px-2 py-2 font-bold">amendmentNumber 1</td>
                        <td class="px-2 py-2 font-bold">natureOfApplicant</td>
                        <td class="px-2 py-2 font-bold">natureOfApplicantDescription</td>
                        <td class="px-2 py-2 font-bold">subject</td>
                        <td class="px-2 py-2 font-bold">Complainants</td>
                        <td class="px-2 py-2 font-bold">Respondent</td>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(amendment,idx) in task.amendments" style="border: solid 1px #dedede;" :key="idx">

                        <td class="px-2 py-1 ">{{ amendment.amendmentNumber }}</td>
                        <td class="px-2 py-1 ">{{ amendment.natureOfApplicant }}</td>
                        <td class="px-2 py-1 ">{{ amendment.natureOfApplicantDescription }}</td>
                        <td class="px-2 py-1 ">{{ amendment.subject }}</td>
                        <td class="px-2 py-1 ">{{
                                amendment.complainants.forEach(com => {
                                    return com.name + ','
                                })
                            }}
                        </td>
                        <td class="px-2 py-1 ">{{
                                amendment.respondents.forEach(com => {
                                    return com.name + ','
                                })
                            }}
                        </td>
                    </tr>

                    </tbody>
                </table>

            </div>
            <div class="col-span-12 my-2" v-else>
                <div class="grid grid-cols-12 gap-4">
                    <div class="col-span-12">


                        <div class="grid grid-cols-12 gap-4" v-if="task.boardResolution">
                            <div class="col-span-12"
                                 :class="task.boardResolution.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                <label class="text-blue fw-bold text-lg">Board Resolution</label>
                                <label class="float-end" v-if="task.boardResolution.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p> Place Of Meeting: <b>{{ task.boardResolution.placeOfMeeting }}</b></p>
                                        <p>Date Of Meeting:
                                            <b>{{ dateFormat(task.boardResolution.dateOfMeeting) }}</b></p>


                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label>
                                            Signatories
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                                                {{ task.boardResolution.resolutionSignatories.length }}
                                            </span>
                                        </label>
                                        <div>
                                            <table style="width: 90%">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>
                                                        Name
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(signatory, idx) in task.boardResolution.resolutionSignatories"
                                                    :key="idx">
                                                    <td>
                                                        {{ idx + 1 }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.signatoryName }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.specialResolution !== undefined">
                            <div class="col-span-12"
                                 :class="task.specialResolution.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.specialResolution">
                                <label class="text-blue fw-bold text-lg">Special Resolution</label>
                                <label class="float-end" v-if="task.specialResolution.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p> Place Of Meeting: <b>{{ task.specialResolution.placeOfMeeting }}</b>
                                            Date Of Meeting:
                                            <b class="mx-2">{{ dateFormat(task.specialResolution.dateOfMeeting) }}</b>
                                        </p>


                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label>
                                            Signatories
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                                                {{ task.specialResolution.resolutionSignatories.length }}
                                            </span>
                                        </label>
                                        <div>
                                            <table style="width: 90%" class="border-gray">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>
                                                        Name
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(signatory, idx) in task.specialResolution.resolutionSignatories"
                                                    :key="idx">
                                                    <td>
                                                        {{ idx + 1 }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.signatoryName }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4" v-if="task.attachments.length> 0">
                            <div class="col-span-12"
                                 :class="task.attachments.length> 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3'">
                                <div class="grid grid-cols-12 gap-4 py-1" v-for="(affair,idxx) in task.attachments" :key="idxx">
                                    <div class="col-span-12">
                                        <label class="text-blue fw-bold text-lg text-capitalize ">
                                            {{ cleanUnderscores(affair.fileDescription) }} </label>
                                        <table class="min-w-full leading-normal">
                                            <thead>
                                            <tr>
                                                <th class="py-1">#</th>
                                                <th class="px-1 py-1">Date Of Effect</th>
                                                <th class="px-1 py-1">Date Of Publication</th>
                                                <th class="px-1 py-1">Publication</th>

                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr style="border: solid 1px #dedede;">
                                                <td class="py-1">
                                                    {{ idxx + 1 }}.
                                                </td>
                                                <td class="px-1 py-1">
                                                    {{ dateFormat(affair.dateOfEffect) }}
                                                </td>
                                                <td class="px-1 py-1">
                          <span>
                            {{ dateFormat(affair.dateOfPublication) }}
                          </span>
                                                </td>
                                                <td class="px-1 py-1">
                          <span>
                            {{ affair.publication }}
                          </span>
                                                </td>

                                            </tr>
                                            </tbody>

                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4" v-if="task.creditorResolution !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.creditorResolution.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3'"
                                 v-if="task.creditorResolution">
                                <label >Creditor Resolution</label>
                                <label class="float-end" v-if="task.creditorResolution.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p> Place Of Meeting: <b>{{ task.creditorResolution.placeOfMeeting }}</b>
                                            Date Of Meeting:
                                            <b class="mx-2">{{ dateFormat(task.creditorResolution.dateOfMeeting) }}</b>
                                        </p>


                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label class="my-2">
                                            Attendees
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                                                {{ task.creditorResolution.attendees.length }}
                                            </span>
                                        </label>
                                        <div>
                                            <table style="width: 90%">
                                                <thead>
                                                <tr class="bg-gray-300 font-bold">
                                                    <th>#</th>
                                                    <th>
                                                        Name
                                                    </th>
                                                    <th>
                                                        Position
                                                    </th>
                                                    <th>
                                                        Phone
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(signatory, idx) in task.creditorResolution.attendees"
                                                    :key="idx">
                                                    <td>
                                                        {{ idx + 1 }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.name }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.position }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.phone }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4" v-if="task.declarationOfSolvency !== undefined ">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.declarationOfSolvency.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.declarationOfSolvency">
                                <label >Declaration of solvency</label>
                                <label class="float-end" v-if="task.declarationOfSolvency.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">


                                        <p>Date declared :
                                            <b>{{ dateFormat(task.declarationOfSolvency.dateOfDeclaration) }}</b></p>


                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label>
                                            Signatories
                                            <span class="bg-gray text-white px-2 py-1 rounded-sm text-xs bg-primary text-capitalize">
                                                {{ task.declarationOfSolvency.signatories.length }}
                                            </span>
                                        </label>
                                        <div>
                                            <table style="width: 90%">
                                                <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>
                                                        Name
                                                    </th>
                                                </tr>
                                                </thead>
                                                <tbody>

                                                <tr v-for="(signatory, idx) in task.declarationOfSolvency.signatories"
                                                    :key="idx">
                                                    <td>
                                                        {{ idx + 1 }}
                                                    </td>
                                                    <td>
                                                        {{ signatory.signatoryName }}
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4 mt-2" v-if="task.finalReport !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.finalReport.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.finalReport">
                                <label >Final Report</label>
                                <label class="float-end" v-if="task.finalReport.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <table class="min-w-full leading-normal mt-1 text-gray"
                                       style="border: solid 1px #dedede;">
                                    <thead>
                                    <tr :class="[task.finalReport.status === 'APPROVED' ? 'bg-green-pale' : 'bg-gray-pale']">
                                        <td colspan="12" class="px-2 py-2 font-bold">Inspection Venue</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                    <td colspan="12">
                                    <div class="grid grid-cols-12 gap-4 mx-1 py-1">
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.physicalAddress.region.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.physicalAddress.district.name.toLowerCase()"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.physicalAddress.subcounty.name"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.physicalAddress.parish.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.physicalAddress.village.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.streetAddress"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.postalAddress"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.postalAddress"
                                                        required>
                                                </input>

                                            </div>

                                            <div class="flex flex-col gap-2 text-sm my-1 flex" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.finalReport.inspectionTime"
                                                        required>
                                                </input>
                                            </div>

                                        </div>
                                    </div>
                                    </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.finalMeeting !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.finalMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.finalMeeting">
                                <label >Final Meeting</label>
                                <label class="float-end" v-if="task.finalMeeting.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">


                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingType"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingDate"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingTime"
                                                    required>
                                            </input>
                                        </div>
                                    </div>

                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingVenue"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.proxyVenue"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.proxyDeadlineDate"
                                                    required>
                                            </input>
                                        </div>
                                    </div>

                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.proxyDeadlineTime"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingCallerName"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.finalMeeting.meetingCallerPosition"
                                                    required>
                                            </input>
                                        </div>
                                    </div>


                                </div>

                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label>Meeting Attendees</label>
                                        <table style="width: 100%">
                                            <thead>
                                            <tr class="bg-gray-pale border-1 text-black">
                                                <td>No.</td>
                                                <td>Name</td>
                                                <td>Position</td>
                                                <td>Phone</td>
                                                <td>Email</td>
                                            </tr>
                                            </thead>

                                            <tbody class="border-1">
                                            <tr v-for="(atd,idx) in task.finalMeeting.attendees" :key="idx">
                                                <td>{{ idx + 1 }}</td>
                                                <td>{{
                                                        atd.entityBrn ? atd.name + ' on behalf of (' + atd.entityName + ')' : atd.name

                                                    }}
                                                </td>
                                                <td>{{ atd.position }}</td>
                                                <td>{{ atd.phone }}</td>
                                                <td>{{ atd.email }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.creditorMeeting !==undefined">

                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.creditorMeeting">
                                <label >Creditors Meeting</label>
                                <label class="float-end" v-if="task.creditorMeeting.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">


                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingType"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingDate"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingTime"
                                                    required>
                                            </input>
                                        </div>
                                    </div>

                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingVenue"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.proxyVenue"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyNa"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.proxyDeadlineDate"
                                                    required>
                                            </input>
                                        </div>
                                    </div>

                                    <div class="col-span-12">
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.proxyDeadlineTime"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingCallerName"
                                                    required>
                                            </input>
                                        </div>
                                        <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                            <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                    id="companyName"
                                                    
                                                    
                                                    :disabled="true"
                                                    :value="task.creditorMeeting.meetingCallerPosition"
                                                    required>
                                            </input>
                                        </div>
                                    </div>


                                </div>

                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <label>Meeting Attendees</label>
                                        <table style="width: 100%">
                                            <thead>
                                            <tr class="bg-gray-pale border-1 text-black">
                                                <td>No.</td>
                                                <td>Name</td>
                                                <td>Position</td>
                                                <td>Phone</td>
                                                <td>Email</td>
                                            </tr>
                                            </thead>

                                            <tbody class="border-1">
                                            <tr v-for="(atd,idx) in task.creditorMeeting.attendees" :key="idx">
                                                <td>{{ idx + 1 }}</td>
                                                <td>{{
                                                        atd.entityBrn ? atd.name + ' on behalf of (' + atd.entityName + ')' : atd.name

                                                    }}
                                                </td>
                                                <td>{{ atd.position }}</td>
                                                <td>{{ atd.phone }}</td>
                                                <td>{{ atd.email }}</td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>


                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.practitionerAppointment !==undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.practitionerAppointment.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.practitionerAppointment">

                                <label >Appointed Practitioner </label>
                                <label class="float-end" v-if="task.practitionerAppointment.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p> Name: <b>{{ task.practitionerAppointment.practitioner.surName }}
                                            {{ task.practitionerAppointment.practitioner.givenName }}</b></p>
                                        <p> UPN: <b>{{ task.practitionerAppointment.practitioner.no }}</b></p>
                                        <p> Type: <b>{{ task.practitionerAppointment.appointmentType }}</b></p>
                                        <p> Status: <span :class="'coloredStatus(task.practitionerAppointment.status)'">{{
                                                task.practitionerAppointment.status
                                            }}</span></p>
                                        <p> Accepted: <b>{{ task.practitionerAppointment.acknowledged }}</b></p>

                                    </div>
                                    <div class="col-span-12">
                                        <p> Email: <b>{{ task.practitionerAppointment.practitioner.emailAddress }}</b>
                                        </p>
                                        <p> Phone: <b>{{ task.practitionerAppointment.practitioner.phoneNumber }}</b>
                                        </p>
                                        <p> Registration Date:
                                            <b>{{ dateFormat(task.practitionerAppointment.practitioner.createdAt) }}</b>
                                        </p>
                                        <p> Appointment Date: <b>{{
                                                dateFormat(task.practitionerAppointment.practitioner.appointmentDate)
                                            }}</b></p>

                                    </div>
                                </div>

                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-for="(practitioner,idx) in task.appointments" :key="idx">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="practitioner.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="practitioner.practitioner">
                                <label >Previously Appointed Practitioners </label>
                                <label class="float-end" v-if="practitioner.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">
                                        <p> Name: <b>{{ practitioner.practitioner.surName }}
                                            {{ practitioner.practitioner.givenName }}</b></p>
                                        <p> UPN: <b>{{ practitioner.practitioner.no }}</b></p>
                                        <p> Email: <b>{{ practitioner.practitioner.emailAddress }}</b></p>
                                    </div>
                                    <div class="col-span-12">
                                        <p> Phone: <b>{{ practitioner.practitioner.phoneNumber }}</b></p>
                                        <p> Registration Date: <b>{{
                                                dateFormat(practitioner.practitioner.createdAt)
                                            }}</b></p>
                                        <p> Appointment Date:
                                            <b>{{ dateFormat(practitioner.practitioner.appointmentDate) }}</b></p>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.lastInterimReport !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.lastInterimReport.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.lastInterimReport">
                                <label >Latest Interim Report</label>
                                <label class="float-end" v-if="task.lastInterimReport.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <table :class=" task.lastInterimReport.status === 'APPROVED' ? 'min-w-full leading-normal mt-1 text-gray' : 'min-w-full leading-normal mt-1 text-gray' "
                                       style="border: solid 1px #dedede;">
                                    <thead>
                                    <tr
                                            :class="[task.lastInterimReport.status === 'APPROVED' ? 'bg-green-pale' : 'bg-gray-pale']"
                                    >
                                        <td colspan="12" class="px-2 py-2 font-bold">Inspection Venue</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                    <td colspan="12">
                                    <div class="grid grid-cols-12 gap-4 mx-1 py-1">
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.physicalAddress.region.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.physicalAddress.district.name.toLowerCase()"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.physicalAddress.subcounty.name"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.physicalAddress.parish.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.physicalAddress.village.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.streetAddress"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.postalAddress"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.postalAddress"
                                                        required>
                                                </input>
                                                <PostalAddressValidator v-if="task.lastInterimReport.postalAddress"
                                                                        :box-number="task.lastInterimReport.postalAddress"/>
                                            </div>

                                            <div class="flex flex-col gap-2 text-sm my-1 flex" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.lastInterimReport.inspectionTime"
                                                        required>
                                                </input>
                                            </div>


                                        </div>
                                    </div>
                                    </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.interimReports !== undefined">
                            <div class="col-span-12 mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3"  v-if="task.interimReports.length> 0" ">
                                <label class="text-blue fw-bold text-lg">Interim Reports</label>
                                <div class="grid grid-cols-12 gap-4 mt-1" v-for="(rpt , idd) in task.interimReports" :key="idd">
                                    <div class="col-span-12"
                                 :class="rpt.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-black fw-bold text-sm">Report Number :
                                            {{ rpt.reportNumber }} </label>
                                        <label class="float-end" v-if="rpt.status ==='APPROVED'"> <i
                                                class="fa fa-lock"></i> </label>
                                        <table class="min-w-full leading-normal mt-1 text-gray"
                                               style="border: solid 1px #dedede;">
                                            <thead>
                                            <tr :class="[rpt.status === 'APPROVED' ? 'bg-green-pale' : 'bg-gray-pale']"
                                            >
                                                <td colspan="12" class="px-2 py-2 font-bold">Inspection Venue</td>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            <tr>
                                            <td colspan="12">
                                            <div class="grid grid-cols-12 gap-4 mx-1 py-1">
                                                <div class="col-span-12">
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.physicalAddress.region.name"
                                                                required>
                                                        </input>
                                                    </div>
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.physicalAddress.district.name.toLowerCase()"
                                                                required>
                                                        </input>
                                                    </div>
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.physicalAddress.subcounty.name"
                                                                required>
                                                        </input>
                                                    </div>
                                                </div>
                                                <div class="col-span-12">
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.physicalAddress.parish.name"
                                                                required>
                                                        </input>
                                                    </div>
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.physicalAddress.village.name"
                                                                required>
                                                        </input>
                                                    </div>
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.streetAddress"
                                                                required>
                                                        </input>
                                                    </div>
                                                </div>
                                                <div class="col-span-12">
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.postalAddress"
                                                                required>
                                                        </input>
                                                    </div>
                                                    <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.postalAddress"
                                                                required>
                                                        </input>
                                                        <PostalAddressValidator v-if="rpt.postalAddress"
                                                                                :box-number="rpt.postalAddress"/>
                                                    </div>

                                                    <div class="flex flex-col gap-2 text-sm my-1 flex" id="input-group-1">
                                                        <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                                id="companyName"
                                                                
                                                                
                                                                :disabled="true"
                                                                :value="rpt.inspectionTime"
                                                                required>
                                                        </input>
                                                    </div>

                                                </div>
                                            </div>
                                            </td>
                                            </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.preliminaryReport !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.preliminaryReport.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.preliminaryReport">
                                <label >Preliminary Report</label>
                                <label class="float-end" v-if="task.preliminaryReport.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <table class="min-w-full leading-normal mt-1 text-gray"
                                       style="border: solid 1px #dedede;">
                                    <thead>
                                    <tr
                                            :class="[task.preliminaryReport.status === 'APPROVED' ? 'bg-green-pale' : 'bg-gray-pale']"
                                    >
                                        <td colspan="12" class="px-2 py-2 font-bold">Inspection Venue</td>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                    <td colspan="12">
                                    <div class="grid grid-cols-12 gap-4 mx-1 py-1">
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.physicalAddress.region.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.physicalAddress.district.name.toLowerCase()"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.physicalAddress.subcounty.name"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.physicalAddress.parish.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.physicalAddress.village.name"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.streetAddress"
                                                        required>
                                                </input>
                                            </div>
                                        </div>
                                        <div class="col-span-12">
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.postalAddress"
                                                        required>
                                                </input>
                                            </div>
                                            <div class="flex flex-col gap-2 text-sm my-1" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.postalAddress"
                                                        required>
                                                </input>
                                                <PostalAddressValidator v-if="task.preliminaryReport.postalAddress"
                                                                        :box-number="task.preliminaryReport.postalAddress"/>
                                            </div>

                                            <div class="flex flex-col gap-2 text-sm my-1 flex" id="input-group-1">
                                                <input
  type="text"
  class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent form-text text-sm noFocus text-capitalize"                                                        id="companyName"
                                                        
                                                        
                                                        :disabled="true"
                                                        :value="task.preliminaryReport.inspectionTime"
                                                        required>
                                                </input>
                                            </div>


                                        </div>
                                    </div>
                                    </td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        <div class="grid grid-cols-12 gap-4" v-if="task.boardResolution !== undefined">
                            <div class="col-span-12 text-blue fw-bold text-lg"
                                 :class="task.boardResolution.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' "
                                 v-if="task.boardResolution">
                                <label >Resolution to Wind Up</label>
                                <label class="float-end" v-if="task.boardResolution.status ==='APPROVED'"> <i
                                        class="fa fa-lock"></i> </label>
                                <div class="grid grid-cols-12 gap-4">
                                    <div class="col-span-12">

                                        <p> Resolution Type: <b>{{ task.boardResolution.resolutionType }}</b></p>
                                        <p> Place Of Meeting: <b>{{ task.boardResolution.placeOfMeeting }}</b></p>
                                        <p>Date Of Meeting:
                                            <b>{{ dateFormat(task.boardResolution.dateOfMeeting) }}</b></p>


                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-if="task.courtOrders && task.courtOrders.length > 0">
                            <label class="text-blue fw-bold text-lg">Court Order details</label>
                            <div class="grid grid-cols-12 gap-4" v-for="(courtOrder,ids) in task.courtOrders" :key="ids">
                                <div class="col-span-12"
                                 :class="courtOrder.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">

                                    <label class="float-end" v-if="courtOrder.status ==='APPROVED'"> <i
                                            class="fa fa-lock"></i> </label>
                                    <div class="grid grid-cols-12 gap-4">
                                        <div class="col-span-2">

                                            Case Number:
                                            <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" disabled v-model="courtOrder.caseNumber" />
                                        </div>
                                        <div class="col-span-2">

                                            Date:
                                            <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" disabled v-model="courtOrder.courtDate" />
                                        </div>
                                        <div class="col-span-2">
                                            Court Venue:
                                            <input type="text" class="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue focus:border-transparent" disabled v-model="courtOrder.issuingCourt" />
                                        </div>
                                        <div class="col-span-12">
                                            Details:
                                            <textarea disabled v-model="courtOrder.description" rows="4"></textarea>

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4" v-if="task.form20 !== undefined">
                            <div class="col-span-12" v-if="task.form20">
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssets?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssets?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4 py-1" v-for="(ast,idxx) in task.form20.nonSecuredAssets"
                                               :key="idxx">
                                            <div class="col-span-12">
                                                <label class="text-blue fw-bold text-lg text-capitalize ">
                                                    {{ cleanEntityType(ast.assetKey) }} </label>
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="py-1">#</th>
                                                        <th class="px-1 py-1">Book Value</th>
                                                        <th class="px-1 py-1">Estimated return value</th>
                                                        <th class="px-1 py-1">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in ast.totals" :key="idx">
                                                        <td class="py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-1 py-1">
                                                            {{ Number(affair.totalBookValue).toLocaleString() }}
                                                        </td>
                                                        <td class="px-1 py-1">
                          <span>
                            {{ Number(affair.totalEstimatedReturn).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-1 py-1">
                          <span>
                            {{ affair.currency }}
                          </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.marketableSecurities?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.marketableSecurities?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <label class="text-blue fw-bold text-lg">Marketable Securities </label>
                                                <label class="float-end"
                                                       v-if="(task.form20?.marketableSecurities?.length ?? 0) > 0"> <i
                                                        class="fa fa-lock"></i> </label>
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1">Name Of Organisation</th>
                                                        <th class="px-2 py-1 text-center">Details Of Security</th>
                                                        <th class="px-2 py-1 text-center">Book value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.marketableSecurities || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.nameOfOrganisation }}
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.detailsOfSecurity }}
                          </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.bookValue).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.estimatedReturn).toLocaleString() }}
                          </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.tradeDebtors?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.tradeDebtors?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <label class="text-blue fw-bold text-lg">Trade Debtors </label>
                                                <label class="float-end"
                                                       v-if="task.form20?.tradeDebtors && Array.isArray(task.form20.tradeDebtors) && task.form20.tradeDebtors.length > 0 && task.form20.tradeDebtors[0]?.status ==='APPROVED'"> <i
                                                        class="fa fa-lock"></i> </label>
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1">Asset</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return value</th>
                                                        <th class="px-2 py-1 text-center">Debtor Address</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.tradeDebtors || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.securityParticulars }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.bookValue).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.estimatedReturn).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ dateFormat(affair.debtorAddress) }}
                          </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.contingentLiabilities?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.contingentLiabilities?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Unsecured creditors - contingent
                                            liabilities </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name and Address of creditor
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Nature of liability</th>
                                                        <th class="px-2 py-1 text-center">Amount of claim</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.contingentLiabilities || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.creditorName }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.description }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.loansAndAdvancesVtoA?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.loansAndAdvancesVtoA?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <label class="text-blue fw-bold text-lg">Loans and Advances </label>
                                                <label class="float-end"
                                                       v-if="task.form20?.loansAndAdvancesVtoA && Array.isArray(task.form20.loansAndAdvancesVtoA) && task.form20.loansAndAdvancesVtoA.length > 0 && task.form20.loansAndAdvancesVtoA[0]?.status ==='APPROVED'"> <i
                                                        class="fa fa-lock"></i> </label>
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1">Number in register</th>
                                                        <th class="px-2 py-1 text-center">ShareHolder Name</th>
                                                        <th class="px-2 py-1 text-center">No of Shares</th>
                                                        <th class="px-2 py-1 text-center">Amount Per Share</th>
                                                        <th class="px-2 py-1 text-center">Total Amount Due</th>
                                                        <th class="px-2 py-1 text-center">Estimated Return</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.tradeDebtors || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{
                                                                Number(affair.noInShareRegister).toLocaleString()
                                                            }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.shareHolderName }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.noOfShares).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.amountPerShare).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.totalAmountDue).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.estimatedReturn).toLocaleString() }}
                          </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.loansAndAdvancesVtoA?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.loansAndAdvancesVtoA?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <label class="text-blue fw-bold text-lg">Loans and Advances Schedule V
                                                    to A</label>
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Number in share register</th>
                                                        <th class="px-2 py-1 text-center">Name address of shareholders
                                                        </th>
                                                        <th class="px-2 py-1 text-center">No of shares</th>
                                                        <th class="px-2 py-1 text-center">Amount of call per share
                                                            capital
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Total amount due</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.tradeDebtors || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ Number(affair.noInShareRegister).toLocaleString() }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.shareHolderName }}
                            {{ affair.shareHolderAddress }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.noOfShares }}
                          </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.amountPerShare }}
                          </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.totalAmountDue }}
                          </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                          <span>
                            {{ affair.estimatedReturn }}
                          </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.assetsSecured?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.assetsSecured?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1">Asset</th>
                                                        <th class="px-2 py-1 text-center">Nature of security</th>
                                                        <th class="px-2 py-1 text-center">Date granted</th>
                                                        <th class="px-2 py-1 text-center">Name of creditor</th>
                                                        <th class="px-2 py-1 text-center">Address and Occupation</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.assetsSecured || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.particularsOfAsset }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.natureOfSecurity }}
                                </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ dateFormat(affair.dateGranted) }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.creditorName }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.address }} &nbsp; {{ affair.occupation }}
                                </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.billOfExchange?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.billOfExchange?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Bills of exchange , promissory notes ,
                                            etc available as assets </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name of bill acceptor</th>
                                                        <th class="px-2 py-1 text-center">Amount of Bill or note</th>
                                                        <th class="px-2 py-1 text-center">Date when due</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Particulars of any property
                                                            held as security for payment of bill or note
                                                        </th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.billOfExchange || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.nameOfAcceptor }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ dateFormat(affair.dateDue) }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.estimatedReturn }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.particulars }}
                                </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.billsPayable?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.billsPayable?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Unsecured creditors - Bills payable
                                            ,promissory notes , etc </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name and address of acceptor
                                                            of bill or note
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Name and address of holder
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Date when due</th>
                                                        <th class="px-2 py-1 text-center">Amount of claim</th>
                                                        <th class="px-2 py-1 text-center">Particulars of bill or note
                                                        </th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.billsPayable || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.nameOfAcceptor }} &nbsp;
                                                            {{ affair.addressOfAcceptor }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.nameOfHolder }} &nbsp; {{ affair.addressOfHolder }}
                                </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ dateFormat(affair.dateDue) }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.particulars }}
                                </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.preferentialCreditors?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.preferentialCreditors?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Preferential creditors for salaries,
                                            wages and otherwise </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name of creditor</th>
                                                        <th class="px-2 py-1 text-center">Address</th>
                                                        <th class="px-2 py-1 text-center">Nature of claim</th>
                                                        <th class="px-2 py-1 text-center">Total amount claim</th>
                                                        <th class="px-2 py-1 text-center">Amount ranking as
                                                            preferential
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Balance not preferential
                                                            carried to list `E`
                                                        </th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.preferentialCreditors || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.creditorName }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.address }}
                                </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.natureOfClaim }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amountOfClaim }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.particulars }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amountRankingAsPreferential }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.balanceNotPreferential }}
                                </span>
                                                        </td>
                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.debenturesSecured?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.debenturesSecured?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">List of holders of debentures secured
                                            by a floating charge </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name and Address of holder
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Amount</th>
                                                        <th class="px-2 py-1 text-center">Description of assets over
                                                            which security extends
                                                        </th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.debenturesSecured || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.holderName }} &nbsp; {{ affair.address }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.address }}
                                </span>
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.assetDescription }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.tradeAccounts?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.tradeAccounts?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Unsecured creditors - trade
                                            accounts </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name and Address of creditor
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Amount of the debt</th>
                                                        <th class="px-2 py-1 text-center">Additional information</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.tradeAccounts || []" :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.creditorName }} &nbsp; {{ affair.address }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.description }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.contingentLiabilities?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.contingentLiabilities?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Unsecured creditors - contingent
                                            liabilities </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Name and Address of creditor
                                                        </th>
                                                        <th class="px-2 py-1 text-center">Nature of liability</th>
                                                        <th class="px-2 py-1 text-center">Amount of claim</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.contingentLiabilities || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.creditorName }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.description }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.amount }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssetsDerivedTotals?.marketableSecurities?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssetsDerivedTotals?.marketableSecurities?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Nonsecured assets - marketable
                                            Securities </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.nonSecuredAssetsDerivedTotals?.marketableSecurities || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.totalBookValue }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.totalEstimatedReturn }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.currency }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssetsDerivedTotals?.tradeDebtors?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssetsDerivedTotals?.tradeDebtors?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Nonsecured assets - Trade
                                            Debtors </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.nonSecuredAssetsDerivedTotals?.tradeDebtors || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.totalBookValue }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                    <span>
                                    {{ affair.totalEstimatedReturn }}
                                    </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                    <span>
                                    {{ affair.currency }}
                                    </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssetsDerivedTotals?.loansAndAdvances?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssetsDerivedTotals?.loansAndAdvances?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Nonsecured assets - Loans and
                                            Advances </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.nonSecuredAssetsDerivedTotals?.loansAndAdvances || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.totalBookValue }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.totalEstimatedReturn }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.currency }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--                  billsReceivable-->

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssetsDerivedTotals?.billsReceivable?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssetsDerivedTotals?.billsReceivable?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Nonsecured assets - Bills
                                            Receivable </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.nonSecuredAssetsDerivedTotals?.billsReceivable || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.totalBookValue }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.totalEstimatedReturn }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.currency }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!--                  unpaidShares-->

                                <div class="grid grid-cols-12 gap-4" v-if="(task.form20?.nonSecuredAssetsDerivedTotals?.unpaidShares?.length ?? 0) > 0">
                                    <div class="col-span-12"
                                 :class="(task.form20?.nonSecuredAssetsDerivedTotals?.unpaidShares?.length ?? 0) > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                        <label class="text-blue fw-bold text-lg">Nonsecured assets - Unpaid
                                            Shares </label>
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <table class="min-w-full leading-normal">
                                                    <thead>
                                                    <tr>
                                                        <th class="px-2 py-1">#</th>
                                                        <th class="px-2 py-1 text-center">Book Value</th>
                                                        <th class="px-2 py-1 text-center">Estimated return</th>
                                                        <th class="px-2 py-1 text-center">Currency</th>

                                                    </tr>
                                                    </thead>
                                                    <tbody>
                                                    <tr style="border: solid 1px #dedede;"
                                                        v-for="(affair, idx) in task.form20?.nonSecuredAssetsDerivedTotals?.unpaidShares || []"
                                                        :key="idx">
                                                        <td class="px-2 py-1">
                                                            {{ idx + 1 }}.
                                                        </td>
                                                        <td class="px-2 py-1">
                                                            {{ affair.totalBookValue }}
                                                        </td>
                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.totalEstimatedReturn }}
                                </span>
                                                        </td>

                                                        <td class="px-2 py-1 text-center">
                                <span>
                                  {{ affair.currency }}
                                </span>
                                                        </td>

                                                    </tr>
                                                    </tbody>

                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                        <div class="grid grid-cols-12 gap-4" v-if="task.reasons !== undefined">
                            <div class="col-span-12" v-if="task.reasons.length>0"
                                   :class="[task.reasons.length > 0 ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3' ]">
                                <div class="grid grid-cols-12 gap-4" v-if="task.reasons.length> 0">
                                    <label class="text-blue fw-bold text-lg">Reasons to Wind Up</label>

                                    <div class="col-span-12" v-for="(reason, idx) in task.reasons" :key="idx">
                                        <div class="grid grid-cols-12 gap-4">
                                            <div class="col-span-12">
                                                <b>{{ idx + 1 }}</b>
                                            </div>
                                            <div class="col-span-11">
                                                <textarea disabled v-model="reason.reason" rows="4"></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <!--     <div class="grid grid-cols-12 gap-4" v-else-if="filing.filingCode === 'FORM29_NOTICE_OF_SPECIAL_RESOLUTION'">
                                               <div class="col-span-12 [task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ]"
                           : v-for="(reason, idx) in filing.data" :key="idx">
                                                   <div class="grid grid-cols-12 gap-4">
                                                       <div class="col-span-12">
                                                           <p> Date Of Cessation:   <b>{{dateFormat(reason.dateOfCessation)}}</b></p>
                                                           <p> Date Of Resolution:   <b>{{dateFormat(reason.dateOfResolving)}}</b></p>
                                                           <p> Venue Of Meeting:   <b>{{reason.venueOfMeeting}}</b></p>
                                                           <p> Name Of Practitioner:   <b>{{reason.nameOfAppointedPractitioner}}</b></p>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                           <div class="grid grid-cols-12 gap-4" v-else-if="filing.filingCode === 'FORM3_ANNUAL_RETURNS'">
                                               <div class="col-span-12"
                                 :class="task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                                   <table class="min-w-full leading-normal">
                                                       <thead>
                                                       <tr>
                                                           <th class="px-2 py-1">#</th>
                                                           <th class="px-2 py-1">Company Number</th>
                                                           <th class="px-2 py-1">Company Name</th>
                                                           <th class="px-2 py-1">UPN</th>
                                                           <th class="px-2 py-1">Practitioner Name</th>
                                                           <th class="px-2 py-1">Practitioner Address</th>
                                                           <th class="px-2 py-1">Prct Postal Address</th>
                                                           <th class="px-2 py-1">Role of Appointee</th>
                                                           <th class="px-2 py-1">Status of Proceeding</th>
                                                           <th class="px-2 py-1">Date of Appointment</th>

                                                       </tr>
                                                       </thead>
                                                       <tbody>
                                                       <tr style="border: solid 1px #dedede;" v-for="(entry, idx) in filing.data" :key="idx">
                                                           <td class="px-2 py-1">
                                                               {{idx+1}}.
                                                           </td>
                                                           <td class="px-2 py-1">{{entry.companyBrn}}</td>
                                                           <td class="px-2 py-1">{{entry.companyName}}</td>
                                                           <td class="px-2 py-1">{{entry.uniquePractitionerNumber}}</td>
                                                           <td class="px-2 py-1">{{entry.practitionerName}}</td>
                                                           <td class="px-2 py-1">{{entry.practitionerAddress}}</td>
                                                           <td class="px-2 py-1">{{entry.practitionerPostalAddress}}</td>
                                                           <td class="px-2 py-1 text-capitalize text-green">{{entry.roleOfTheAppointee.toLowerCase()}}</td>
                                                           <td class="px-2 py-1 text-capitalize text-blue">{{cleanString(entry.statusOfProceeding).toLowerCase()}}</td>
                                                           <td class="px-2 py-1">
                                                               <span>{{dateFormat(entry.dateOfAppointment)}}</span>
                                                           </td>
                                                       </tr>
                                                       </tbody>

                                                   </table>
                                               </div>
                                           </div>
                                           <div class="grid grid-cols-12 gap-4" v-else-if="filing.filingCode === 'FORM25_NOTICE_OF_LIQUIDATORS_REPORT'">
                                               <div class="col-span-12"
                                 :class="task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ">
                                                   <table class="min-w-full leading-normal">
                                                       <thead>
                                                       <tr>
                                                           <th class="px-2 py-1">#</th>
                                                           <th class="px-2 py-1">Company Number</th>
                                                           <th class="px-2 py-1">Company Name</th>
                                                           <th class="px-2 py-1">Liquidator</th>
                                                           <th class="px-2 py-1">Inspection Venue</th>
                                                           <th class="px-2 py-1">Report Type</th>
                                                           <th class="px-2 py-1">Inspection Start</th>
                                                           <th class="px-2 py-1">Inspection End</th>
                                                           <th class="px-2 py-1">Date of Report</th>

                                                       </tr>
                                                       </thead>
                                                       <tbody>
                                                       <tr style="border: solid 1px #dedede;" v-for="(report, idx) in filing.data" :key="idx">
                                                           <td class="px-2 py-1">
                                                               {{idx+1}}.
                                                           </td>
                                                           <td class="px-2 py-1">{{report.companyBrn}}</td>
                                                           <td class="px-2 py-1">{{report.companyName}}</td>
                                                           <td class="px-2 py-1">{{report.nameOfLiquidator}}</td>
                                                           <td class="px-2 py-1">{{report.inspectionVenue}}</td>
                                                           <td class="px-2 py-1">{{cleanString(report.reportType)}}</td>
                                                           <td class="px-2 py-1">{{report.inspectionStartTime}}</td>
                                                           <td class="px-2 py-1">{{report.inspectionEndTime}}</td>
                                                           <td class="px-2 py-1">
                                                               <span>{{dateFormat(report.dateOfReport)}}</span>
                                                           </td>
                                                       </tr>
                                                       </tbody>

                                                   </table>
                                               </div>
                                           </div>
                                           <div class="grid grid-cols-12 gap-4" v-else-if="filing.filingCode === 'FORM30_DECLARATION_OF_SOLVENCY'">
                                               <div class="col-span-12 [task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ]"
                           : v-for="(reason, idx) in filing.data" :key="idx">
                                                   <div class="grid grid-cols-12 gap-4">
                                                       <div class="col-span-12">
                                                           <p>Directors;</p>
                                                           <div class="grid grid-cols-12 gap-4" v-for="(director, idx) in reason.namesOfDirector" :key="idx">
                                                               <div class="col-span-12">
                                                                   <p> - {{director}}</p>
                                                               </div>
                                                           </div>
                                                           <p class="mt-2" > Date Filed:   <b>{{dateFormat(reason.creationDate)}}</b></p>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                           <div class="grid grid-cols-12 gap-4" v-else-if="filing.filingCode === 'FORM12_NOTICE_OF_APPOINTMENT'">
                                               <div class="col-span-12 [task.creditorMeeting.status ==='APPROVED' ? 'bg-inertgrey mx-auto border border-gray-10 shadow-sm rounded-sm m-2 py-3':'mx-auto py-3' ]"
                           : v-for="(reason, idx) in filing.data" :key="idx">
                                                   <div class="grid grid-cols-12 gap-4">
                                                       <div class="col-span-12">
                                                           <p> Name of Appointee:   <b>{{reason.nameOfAppointee}}</b></p>
                                                           <p> Role of Appointee:   <b>{{reason.roleOfTheAppointee}}</b></p>
                                                           <p> Date of Filed:  <b>{{dateFormat(reason.dateOfFiling)}}</b></p>
                                                       </div>
                                                   </div>
                                               </div>
                                           </div>
                                           -->


                            </div>
                        </div>


                    </div>
                </div>


            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { dateFormat, dateTimeFormat } from "@/commons/composables/transformations.ts";
import { cleanEntityType, cleanUnderscores } from "@/commons/composables/utilities.ts";

interface Task {
  brn?: string
  companyName?: string
  entityType?: string
  subType?: string
  dateOfIncorporation?: string
  applicant?: {
    givenName: string
    surname?: string
    email: string
    phoneNumber: string
  }
  trackingNumber: string
  status: string
  type: string
  windingUpType?: string
  hasAsset?: string
  createdAt: string
  petition?: any
  amendments?: any[]
  boardResolution?: any
  specialResolution?: any
  attachments: any[]
  creditorResolution?: any
  declarationOfSolvency?: any
  finalReport?: any
  reasons?: any[]
  finalMeeting?: any
  creditorMeeting?: any
  practitionerAppointment?: any
  lastInterimReport?: any
  interimReports?: any[]
  preliminaryReport?: any
  appointments?: any[]
  courtOrders?: any[]
  form20?: {
    tradeAccounts?: any[]
    contingentLiabilities?: any[]
    marketableSecurities?: any[]
    tradeDebtors?: any[]
    loansAndAdvancesVtoA?: any[]
    assetsSecured?: any[]
    billOfExchange?: any[]
    billsPayable?: any[]
    preferentialCreditors?: any[]
    debenturesSecured?: any[]
    nonSecuredAssetsDerivedTotals?: {
      loansAndAdvances?: any[]
      billsReceivable?: any[]
      unpaidShares?: any[]
      marketableSecurities?: any[]
      tradeDebtors?: any[]
    }
    nonSecuredAssets?: any[]
  }
}

defineProps<{
  task: Task
}>()

const coloredStatus = (status: string): string => {
  if (status === 'APPROVED') {
    return 'text-green'
  } else if (status === 'REJECTED') {
    return 'text-red'
  } else if (status === 'FILING') {
    return 'text-gray'
  }
  return ''
}
</script>

